/**
 * Support-request form schema, derived from the generated Zod request body.
 * See ./README.md for why this lives in the webapp package.
 */
import { z } from 'zod';

import { SupportRequestsCreateBody } from '~/data/generated/zod/support/support.zod';

/**
 * Drives the SupportRequestDialog form (zodResolver), so it carries two
 * app-side overrides the wire schema has no concept of.
 */
export const supportRequestCreateSchema = SupportRequestsCreateBody.extend({
  // The generated `.min(1)` has no message; this one is shown under the field.
  message: z.string().min(1, 'Please describe your request'),
  // The dialog does not collect a page URL — it is attached from
  // window.location at submit time. The generated `.url().default('')` runs its
  // own default through `.url()`, so inheriting it would fail validation on
  // every submit for a field the form never renders.
  pageUrl: z.string().optional(),
});
export type SupportRequestCreate = z.infer<typeof supportRequestCreateSchema>;
